import { render, staticRenderFns } from "./PhotovoltaicModuleFormGroup.vue?vue&type=template&id=5159671c&"
import script from "./PhotovoltaicModuleFormGroup.vue?vue&type=script&lang=ts&"
export * from "./PhotovoltaicModuleFormGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports